class BaseEvaluateExpressionError extends Error {
  shouldReport?: boolean;

  get type(): string { return this.constructor.name; }
}

export default BaseEvaluateExpressionError;
